import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import { Row, Col, Card, Tabs, Tab, Spinner, Badge, Modal } from 'react-bootstrap'
import Carousel from 'react-bootstrap/Carousel';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";


import { FaHeart, FaTruck, FaFacebookMessenger, FaSketch, FaRegHeart, FaRegCommentAlt, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { BsStarFill, BsStarHalf, BsStar, BsEye, BsBookmark, BsChatSquareQuote } from "react-icons/bs";
import { text } from '@fortawesome/fontawesome-svg-core';
import { FcFlashOn } from "react-icons/fc";

import { BrowserRouter, Routes, Route, NavLink, useParams, useNavigate, Link } from "react-router-dom";

import { firestore } from '../../Database/firebase';
import "./content.css";

// import MessengerCustomerChat from 'react-messenger-customer-chat';
// import ChatBot from '../Chat/FacebookChat';

function SuggestionBookView() {



   
    const [bookLists, setBookLists] = useState([]);
    const [currentCursor, setCurrentCursor] = useState("");
   
      useEffect(() => {
           const firsPageRef = firestore
               .collection("product")
               .where("publicWebStatus", "==", 1)
               .orderBy("productRatingCount", "desc")
               .limit(8);
           firsPageRef.get().then((querySnapshot) => {
               let tempLists = [];
               querySnapshot.docs.forEach((doc) => {
                   if (doc.exists) {
   
                       const currentBook = {
   
                               id: doc.id,
                               productID: doc.data().productID,
                               merchantName: doc.data().merchantName,
                               productName: doc.data().productName,
                               productImage: doc.data().productImage,
                               productFullPrice: doc.data().productFullPrice,
                               productPrice: doc.data().productPrice,
                               productCategory: doc.data().productCategory,
                               productSubCategory: doc.data().productSubCategory,
                               productTypeCategory: doc.data().productTypeCategory,
   
                               productRatingSum: doc.data().productRatingSum,
                               productRatingCount: doc.data().productRatingCount,
   
                               saleCount: doc.data().saleCount,
   
                               publicWebStatus: doc.data().publicWebStatus,
   
   
                           //RATING
                           /* ratingSum: doc.data().ratingSum,
                           ratingCount: doc.data().ratingCount, */
   
                       };
                       tempLists = [...tempLists, currentBook];
                       //setWriterID(doc.data().writerID);
                   }
               });
   
   
               setBookLists((prv) => tempLists);
               const currentLenght = querySnapshot.docs.length;
               const currentCursorFromFirstPage = querySnapshot.docs[currentLenght - 1];
               setCurrentCursor(currentCursorFromFirstPage);
           })
       }, []);
   
       const onMoreBooks = () => {
           const nextPageRef = firestore
               .collection("product")
               .where("publicWebStatus", "==", 1)
               .orderBy("productRatingCount", "desc")
               .limit(8);
           nextPageRef.get().then((querySnapshot) => {
               const currentLenght = querySnapshot.docs.length;
               if (!currentCursor) {
                   return;
               }
               const query = nextPageRef.startAfter(currentCursor);
               query.get().then((querySnapshot) => {
                   let tempNewArray = [];
                   querySnapshot.forEach((doc) => {
                       if (doc.exists) {
                           tempNewArray = [
                               ...tempNewArray,
                               {
                                   id: doc.id,
                                   productID: doc.data().productID,
                                   merchantName: doc.data().merchantName,
                                   productName: doc.data().productName,
                                   productImage: doc.data().productImage,
                                   productFullPrice: doc.data().productFullPrice,
                                   productPrice: doc.data().productPrice,
                                   productCategory: doc.data().productCategory,
                                   productSubCategory: doc.data().productSubCategory,
                                   productTypeCategory: doc.data().productTypeCategory,
   
                                   productRatingSum: doc.data().productRatingSum,
                                   productRatingCount: doc.data().productRatingCount,
   
                                   saleCount: doc.data().saleCount,
   
                                   publicWebStatus: doc.data().publicWebStatus,
   
                                   //RATING
                                   /* ratingSum: doc.data().ratingSum,
                                   ratingCount: doc.data().ratingCount, */
                               },
                           ];
   
                           //setWriterID(doc.data().writerID);
                       }
                   });
   
   
                   setBookLists([...bookLists, ...tempNewArray]);
                   const currentCursorForNextPage = querySnapshot.docs[currentLenght -1];
                   setCurrentCursor(currentCursorForNextPage);
               });
           });
       };


       

        const newDataSource = [...new Set(bookLists.map(item => (item.productCategory)))]

        const newData = newDataSource.filter(function (el) {
          return el != null;
        });


    return (

    <div>

    <Container className="bordernewestarticle" style={{backgroundColor: 'white'}}>

        <br/>

        

        <h3 style={{fontWeight: 'bold'}}><strong><BsChatSquareQuote/> แนะนำ</strong></h3>
        <br/>
                    <div style={{textDecoration: 'none', color: "black"}}>
                        <div>
                          {newData.map((prop, key) => {
                            return (
                            <>
                              {({prop} != "") ? (
        
                                <span class="badge rounded-pill bg-light text-dark" style={{marginRight: 5}}>
                                    
                            
                                    
                                        
                                            <Link to={'/Category/'+ prop} key={key} style={{textDecoration: 'none', color: "black"}}><h5 style={{fontSize: 20, fontWeight: 'bold', padding: 2}}>{prop}</h5></Link> 
                                        
                                    
                                   
                                </span>
        
                              ) : (
        
                                <>
                                </>
        
                              )}
        
                            </>
        
                            );
                          })}
                        </div>
                    </div>
        {/* <h3><span class="badge rounded-pill bg-light text-dark">อาญา</span> <span class="badge rounded-pill bg-light text-dark">แพ่ง</span> <span class="badge rounded-pill bg-light text-dark">วิอาญา</span> <span class="badge rounded-pill bg-light text-dark">วิแพ่ง</span></h3>
         */}
        <br/>
        


            <Row xs={2} md={4} className="sm-4">

            {bookLists.map((item) => {
                            
                return (
                               
                    <div key={item.id}>



                                <div>
                                    <Link to={'/ProductView/'+ item.productID} style={{textDecoration: 'none', color: "black"}}>
                                        <Card className="cardarticle">

                                            {!!item.productImage ? (
                                                <Card.Img variant="top" class='cardarticledetailimg' style={{marginLeft: 'auto', marginRight: 'auto'}} src={item.productImage} />
                                            ) : (
                                                <Col style={{backgroundColor: '#FFFAFA'}}><div class='cardarticledetailnoimg'><strong>{(item.merchantName)}</strong></div></Col>
                                            )}
                                            
                                            
                                            <Card.Body class='cardarticledetail'>
                                                <Card.Title>
                                                </Card.Title>

                                                {/* <p class='articlename'>{item.productName}</p> */}
                                                
                                                <p class='articlename'><Badge bg="warning" text="dark">{item.productTypeCategory}</Badge> {item.productName}</p>
                                                                                           
                                                {/* <p class='cardarticledetailnamedatetime'>{item.merchantName} <br/> {(item.articleDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})} | {(item.articleDate).toDate().toLocaleTimeString()}  */}
                                                <p class='cardarticledetailnamedatetime'><span style={{fontSize: 10}}>{item.merchantName}</span>
                                                    
                                                </p>

                                                <div class='cardarticledetailnamedatetime' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: -15 }}>
                                                    <span style={{ fontWeight: 'bold', color: 'tomato' }}>
                                                        ฿{item.productPrice}
                                                        <span style={{ textDecoration: 'line-through', marginLeft: 5 }}>
                                                        ฿{item.productFullPrice}
                                                        </span>
                                                    </span>
                                                    <span style={{fontSize: 12}}>ขายแล้ว {item.saleCount}</span>
                                                </div>
                                             
                                                
                                                {/* <span class='cardarticledetaillikebookmark'><strong><FaRegHeart/> {item.likeCount}</strong><strong>&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p> */}
   
                                                    
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </div>


                    </div>

                )
            })}

            </Row>

            <br/>
            <br/>

      
            {currentCursor ? (
                <Col className='text-center'>

                    <Button variant="warning rounded-pill" className="rounded-0" onClick={onMoreBooks}>แสดงเพิ่มเติม</Button>
        
                </Col>
            ) : (
                <Col className='text-center'>

                    <Button variant="outline-dark rounded-pill" className="rounded-0" disabled>ไม่มีหนังสือเพิ่มเติม</Button>
        
                </Col>
            )}

            <br/>
           
    </Container>



        {/* <MessengerCustomerChat pageId="100085795429971" appId="160341680355677" /> */}

        {/* <ChatBot /> */}
    
    </div>

  );
}

export default SuggestionBookView;